import { DatePipe, formatDate } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgxSpinner, NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AppointmentService } from '../../services/appointment.service';

@Component({
  selector: 'app-todays-appointment',
  templateUrl: './todays-appointment.component.html',
  styleUrls: ['./todays-appointment.component.scss']
})
export class TodaysAppointmentComponent implements OnInit {

  myDate: any;
  
  constructor(
    private http: HttpClient,
    private appointmentService: AppointmentService,
    private authService: AuthenticationService,
    private spinner:NgxSpinnerService
  ) {
    
   // this.myDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
  }

  value: String = 'todays';
  appointments: any = [];
  userRole: any;
  show:boolean=false
  ngOnInit(): void {
    this.show=false;
    this.spinner.show()
    let location=null;
    let diagId=null;
    jQuery('.modal-backdrop.fade.show').remove();
    let status="REVIEWED";
    this.userRole = this.authService.getUserType();
    const cValue = formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
    this.appointmentService.getAppointments(location,diagId,status,null,cValue,cValue).subscribe(res=>{
      this.appointments=res.data;
      if (this.appointments.length > 0) {
        this.appointments = this.appointments.sort((a: any, b: any) =>(new Date(a.appointmentDetails.schedules[0].appointmentDate)  <= new Date (b.appointmentDetails.schedules[0].appointmentDate) ? -1 : 1));
      }
      this.show=true;
      this.spinner.hide()
    })
  }
  getAppointments() {}
  selectValue(value: string) {
    this.value = value;
  }
}
